import { render, staticRenderFns } from "./session-item.vue?vue&type=template&id=6fa3132c&scoped=true&"
import script from "./session-item.vue?vue&type=script&lang=js&"
export * from "./session-item.vue?vue&type=script&lang=js&"
import style0 from "./session-item.vue?vue&type=style&index=0&id=6fa3132c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa3132c",
  null
  
)

export default component.exports